module.exports = __webpack_public_path__ + "img/DTYLX_pl.fa13fad0.png";